
  export const style={
    inpuStyle:{
      colorInput:"#F58220"
    },
    url:{
      urlClient:"https://smarthub.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_smarthub.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"SMARTCOIN/SMARTCOINS"
    },
    teamName:{
      name:"SmartHub"
    },
    hasToken: true,
    hostHeader: "smarthub"
  }
